var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "span",
    {
      staticClass: "gfu-contact-form__back-navigation",
      attrs: { "data-qa": "contact-form-btn:GoBack" },
      on: {
        click: function ($event) {
          $event.preventDefault()
          return _vm.$emit("click")
        },
      },
    },
    [
      _c("base-icon", {
        staticClass: "_mr-1",
        attrs: { name: "chevron-left" },
      }),
      _vm._v(_vm._s(_vm.Resources.Common.GoBackButton) + "\n"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }